const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const isToday = date.toDateString() === now.toDateString();
    const isCurrentYear = date.getFullYear() === now.getFullYear();

    const timeString = date.toLocaleTimeString('en-US', { 
        hour: 'numeric', 
        minute: '2-digit',
        hour12: true 
    });

    if (isToday) {
        return `${timeString} Today`;
    }

    const dateFormat = isCurrentYear 
        ? { month: 'short', day: 'numeric' }
        : { month: 'short', day: 'numeric', year: 'numeric' };

    return `${timeString} ${date.toLocaleDateString('en-US', dateFormat)}`;
};

const formatDateTimeWithoutSeconds = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleDateString('en-US', { 
        month: 'short', 
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    });
};

export {
  formatTime,
  formatDateTimeWithoutSeconds
}
